export default "/images/ea4e3120f2b80d394e3b82b6c406646d.avif";